import {
  AnyAction,
  PayloadAction,
  createAsyncThunk,
  createSlice,
} from '@reduxjs/toolkit';
import {
  ContactToLead,
  GetContactById,
  GetGlobalSearch,
  GetInstituteByIdRequest,
  InstitutionsRequest,
} from './institute.request';
import {
  InstitutionsDTO,
  InstitutionsDetailsDTO,
  InstitutionsInitialStateDTO,
} from './types';
import { SetActiveInstitute } from '../../../../../service/activeInstituteSlice';
import { setToastNotification } from '../../../../../components/ToastNotification/service/toastNotificationSlice';

export const initialState: InstitutionsInitialStateDTO = {
  error: false,
  success: false,
  loading: false,
  instituteDetails: null,
  globalSearchsData: null,
  contactById: null,
  fileUploadSuccess: false,
  instituteDetailsLoading: false,
  instituteUpdateloading: false,
  instituteUpdateSuccess: false,
  instituteByIdLoading: false,
  globalSearchLoading: false,
  contactByIdLoading: false,
  contactModalState: false,
  convertToLeadLoading: false,
  convertToLeadSuccess: false,
  globalSearchModalState: false,
  globalSearchRequestId: 0,
  convertedContactId: null,
};

export const institute = createAsyncThunk(
  '/institutes',
  (data: InstitutionsDTO, { dispatch }) => {
    return InstitutionsRequest(data)
      .then((response: any) => {
        if (response.status === 200) {
          dispatch(SetActiveInstitute(data?.id));
        }
        if (response) {
          dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: 'success',
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: 'error',
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);
export const getInstituteById = createAsyncThunk(
  '/institute/id',
  (data: string, { dispatch }) => {
    return GetInstituteByIdRequest(data)
      .then((response: any) => {
        if (response.status === 200) {
          localStorage.setItem(
            'ACTIVE_INSTITUTE',
            JSON.stringify(response?.data?.data)
          );
          // dispatch(SetActiveInstitute(response?.data?.data?.id));
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const getGlobalSearch = createAsyncThunk(
  'nurture/globalSearch',
  async (
    { data, requestId }: { data: any; requestId: number },
    { dispatch }
  ) => {
    try {
      const response = await GetGlobalSearch(data);
      return {
        response: response?.data?.data,
        requestId,
      };
    } catch (e: any) {
      dispatch(
        setToastNotification({
          message: e?.response?.data?.message,
          type: 'error',
          snackOpen: true,
        })
      );
      throw e.response?.data;
    }
  }
);

export const getContactById = createAsyncThunk(
  '/contact/id',
  (data: string, { dispatch }) => {
    return GetContactById(data)
      .then((response: any) => {
        if (response.status === 200) {
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const contactToLead = createAsyncThunk(
  'contact/contactToLead',
  (data: any, { dispatch }) => {
    return ContactToLead(data)
      .then((response: any) => {
        if (response) {
          dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: 'success',
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: 'error',
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const instituteSlice = createSlice({
  name: 'institute',
  initialState,
  reducers: {
    reset: () => initialState,
    clearSuccess: (state) => {
      state.success = false;
    },
    resetInstitiuteStatuses: (state) => {
      state.instituteUpdateSuccess = false;
    },
    updateInstituteDetails: (
      state,
      action: PayloadAction<InstitutionsDetailsDTO>
    ) => {
      state.instituteDetails = action.payload;
    },
    setContactModalState: (state) => {
      state.contactModalState = true;
    },
    resetContactModalState: (state) => {
      state.contactModalState = false;
      state.contactById = null;
      state.convertToLeadSuccess = false;
    },
    setGlobalSearchModalState: (state) => {
      state.globalSearchModalState = true;
    },
    resetGlobalSearchModalState: (state) => {
      state.globalSearchModalState = false;
      state.globalSearchsData = null;
      state.convertedContactId = null;
    },
    resetGlobalSearchsData: (state) => {
      state.globalSearchsData = null;
    },
    resetConvertedContactId: (state) => {
      state.convertedContactId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(institute.pending, (state) => {
      state.instituteUpdateloading = true;
      state.error = false;
      state.instituteUpdateSuccess = false;
    });
    builder.addCase(institute.fulfilled, (state, action: AnyAction) => {
      state.instituteUpdateloading = false;
      state.instituteUpdateSuccess =
        action?.payload?.message || 'Institute Profile Updated Successfully';
      state.error = false;
    });
    builder.addCase(institute.rejected, (state, action: AnyAction) => {
      state.instituteUpdateloading = false;
      state.error = action?.payload?.message || 'Something went wrong';
      state.instituteUpdateSuccess = false;
    });
    builder.addCase(getInstituteById.pending, (state) => {
      state.instituteByIdLoading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getInstituteById.fulfilled,
      (state, action: PayloadAction<InstitutionsDetailsDTO>) => {
        state.instituteByIdLoading = false;
        state.success = true;
        state.error = false;
        state.instituteDetails = action?.payload;
      }
    );
    builder.addCase(getInstituteById.rejected, (state, action: AnyAction) => {
      state.instituteByIdLoading = false;
      state.success = false;
      state.error = action?.error?.message || 'Something went wrong';
    });
    builder.addCase(getGlobalSearch.pending, (state, action: AnyAction) => {
      state.globalSearchLoading = true;
      state.success = false;
      state.error = false;
      state.globalSearchRequestId = action.meta.arg.requestId;
    });
    builder.addCase(getGlobalSearch.fulfilled, (state, action: AnyAction) => {
      if (action?.meta.arg.requestId === state.globalSearchRequestId) {
        state.globalSearchLoading = false;
        state.success = true;
        state.error = false;
        state.globalSearchsData = action?.payload?.response;
      }
    });
    builder.addCase(getGlobalSearch.rejected, (state, action: AnyAction) => {
      if (action?.meta.arg.requestId === state.globalSearchRequestId) {
        state.globalSearchLoading = false;
        state.success = false;
        state.error = action?.error?.message || 'Something went wrong';
      }
    });
    builder.addCase(getContactById.pending, (state) => {
      state.contactByIdLoading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getContactById.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.contactByIdLoading = false;
        state.success = true;
        state.error = false;
        state.contactById = action?.payload;
      }
    );
    builder.addCase(getContactById.rejected, (state, action: AnyAction) => {
      state.contactByIdLoading = false;
      state.success = false;
      state.error = action?.error?.message || 'Something went wrong';
    });

    builder.addCase(contactToLead.pending, (state) => {
      state.convertToLeadLoading = true;
      state.convertToLeadSuccess = false;
      state.error = false;
    });
    builder.addCase(
      contactToLead.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.convertToLeadLoading = false;
        state.convertToLeadSuccess = action?.payload?.message || 'Lead created';
        state.error = false;
        state.convertedContactId = action?.payload?.data?.id || null;
      }
    );
    builder.addCase(contactToLead.rejected, (state, action: AnyAction) => {
      state.convertToLeadLoading = false;
      state.convertToLeadSuccess = false;
      state.error = action?.error?.message || 'Something went wrong';
    });
  },
});

export default instituteSlice.reducer;
export const {
  reset,
  resetInstitiuteStatuses,
  updateInstituteDetails,
  setContactModalState,
  resetContactModalState,
  resetGlobalSearchsData,
  resetGlobalSearchModalState,
  setGlobalSearchModalState,
  resetConvertedContactId,
} = instituteSlice.actions;
